import React, { useState } from 'react';
import { Search, Filter } from 'lucide-react';

const mockStockData = [
    { id: 1, date: '05/11/2024', centerName: 'WEREHOUSE SEC 63', productName: 'Shilajit 25-Gold 30 Capsules', category: 'Aayurvedic', stockIn: 1200, stockOut: 600, balance: 1160 },
    { id: 2, date: '05/11/2024', centerName: 'WEREHOUSE SEC 63', productName: 'Thron of toofan 25 oil', category: 'Aayurvedic', stockIn: 990, stockOut: 1000, balance: 759 },
    { id: 3, date: '05/11/2024', centerName: 'WEREHOUSE SEC 63', productName: 'Aarogya India Noni Juice', category: 'Aayurvedic', stockIn: 1100, stockOut: 1200, balance: 467 },
    { id: 4, date: '05/11/2024', centerName: 'WEREHOUSE SEC 63', productName: 'Haldi Chandan Face Wash', category: 'Cosmetic', stockIn: 1200, stockOut: 990, balance: 1197 },
    { id: 5, date: '05/11/2024', centerName: 'WEREHOUSE SEC 63', productName: 'ComoFin', category: 'Allopathic', stockIn: 800, stockOut: 700, balance: 445 },
    { id: 6, date: '05/11/2024', centerName: 'WEREHOUSE SEC 63', productName: 'Shilajit 25-Gold 30 Capsules', category: 'Aayurvedic', stockIn: 1200, stockOut: 600, balance: 1160 },
    { id: 7, date: '05/11/2024', centerName: 'WEREHOUSE SEC 63', productName: 'Thron of toofan 25 oil', category: 'Aayurvedic', stockIn: 990, stockOut: 1000, balance: 759 },
    { id: 8, date: '05/11/2024', centerName: 'WEREHOUSE SEC 63', productName: 'Aarogya India Noni Juice', category: 'Aayurvedic', stockIn: 1100, stockOut: 1200, balance: 467 },
    { id: 9, date: '05/11/2024', centerName: 'WEREHOUSE SEC 63', productName: 'Haldi Chandan Face Wash', category: 'Cosmetic', stockIn: 1200, stockOut: 990, balance: 1197 },
    { id: 10, date: '05/11/2024', centerName: 'WEREHOUSE SEC 63', productName: 'ComoFin', category: 'Allopathic', stockIn: 800, stockOut: 700, balance: 445 },
];

function LedgerStock() {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredData = mockStockData.filter(row =>
        row.productName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        row.centerName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const calculateTotals = () => {
        let openingQuantity = 0;
        let closingQuantity = 0;

        filteredData.forEach(row => {
            // For opening quantity we'll dynamically use the stockIn values,
            // minus whatever was stocked out previously, to emulate a running tally 
            // from the mocked dataset.
            openingQuantity += (row.stockIn || 0);

            // Adding the given balance directly to closing to represent remaining stock per row
            closingQuantity += (row.balance || 0);
        });

        // Add formatting for thousands and millions commas
        const formatBal = (amount) => amount.toLocaleString('en-IN');

        return {
            openingQuantity: formatBal(openingQuantity),
            closingQuantity: formatBal(closingQuantity)
        };
    };

    const totals = calculateTotals();

    return (
        <div className="w-full flex flex-col space-y-6 pb-10">
            {/* Title */}
            <div>
                <h1 className="text-[22px] font-bold text-[#1F3D36]">Ledger</h1>
            </div>

            {/* Toolbar */}
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div className="flex flex-wrap items-center gap-3 w-full md:w-auto">
                    {/* Search bar */}
                    <div className="relative w-full sm:w-[350px]">
                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                            <Search className="w-4 h-4 text-[#8CACA0]" />
                        </div>
                        <input
                            type="text"
                            placeholder="Search by company name"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full pl-11 pr-4 py-2 border border-[#D5E1DC] rounded-full focus:outline-none focus:ring-1 focus:ring-teal-500 text-sm placeholder:text-[#A8C1B7]"
                        />
                    </div>

                    {/* Filter button */}
                    <button className="flex-shrink-0 w-[42px] h-[42px] flex items-center justify-center border border-[#D5E1DC] rounded-full bg-white hover:bg-gray-50 transition-colors">
                        <Filter className="w-5 h-5 text-[#8CACA0]" />
                    </button>
                </div>

                {/* Opening Quantity */}
                <div className="text-[#1F3D36] ml-auto">
                    <span className="text-sm font-bold mr-2">Opening quantity:</span>
                    <span className="text-[24px] font-medium leading-none">{totals.openingQuantity}</span>
                </div>
            </div>

            {/* Table Section */}
            <div className="bg-white border border-[#F1F5F3] rounded-[16px] overflow-hidden shadow-sm flex flex-col min-h-[500px]">
                {/* Responsive Table Wrapper for Horizontal Scroll */}
                <div className="overflow-x-auto w-full">
                    <div className="min-w-[1000px]">
                        {/* Table Header */}
                        <div className="grid grid-cols-[1fr_2fr_2.5fr_1.5fr_1fr_1fr_1.5fr] px-8 py-5 border-b border-[#F1F5F3] bg-white gap-4">
                            <div className="text-[11px] font-bold text-[#8CACA0] uppercase tracking-wider">DATE</div>
                            <div className="text-[11px] font-bold text-[#8CACA0] uppercase tracking-wider">CENTER NAME</div>
                            <div className="text-[11px] font-bold text-[#8CACA0] uppercase tracking-wider">PRODUCT NAME</div>
                            <div className="text-[11px] font-bold text-[#8CACA0] uppercase tracking-wider">PRODUCT CATEGORY</div>
                            <div className="text-[11px] font-bold text-[#8CACA0] uppercase tracking-wider">STOCK IN</div>
                            <div className="text-[11px] font-bold text-[#8CACA0] uppercase tracking-wider">STOCK OUT</div>
                            <div className="text-[11px] font-bold text-[#8CACA0] uppercase tracking-wider text-right">BALANCE STOCK</div>
                        </div>

                        {/* Table Body */}
                        <div className="overflow-y-auto max-h-[60vh] pb-4">
                            {filteredData.map((row, index) => (
                                <div
                                    key={index}
                                    className={`grid grid-cols-[1fr_2fr_2.5fr_1.5fr_1fr_1fr_1.5fr] px-8 py-[18px] hover:bg-teal-50/50 transition-colors items-center gap-4 ${index % 2 === 0 ? 'bg-[#FCFEFD]' : 'bg-white'}`}
                                >
                                    <div className="text-[13px] font-medium text-[#1F3D36]">{row.date}</div>
                                    <div className="text-[13px] text-[#4E6E64] uppercase">{row.centerName}</div>
                                    <div className="text-[13px] font-medium text-[#1F3D36]">{row.productName}</div>
                                    <div className="text-[13px] text-[#4E6E64]">{row.category}</div>
                                    <div className="text-[13px] text-[#4E6E64]">{row.stockIn}</div>
                                    <div className="text-[13px] text-[#4E6E64]">{row.stockOut}</div>
                                    <div className="text-[13px] font-medium text-[#1F3D36] text-right">{row.balance}</div>
                                </div>
                            ))}
                            {filteredData.length === 0 && (
                                <div className="p-8 text-center text-gray-500">
                                    No stock found.
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <div className="flex justify-end pr-2 pt-1">
                <div className="text-[#1F3D36] flex items-baseline">
                    <span className="text-[15px] font-bold mr-3">Closing quantity:</span>
                    <span className="text-[28px] font-medium">{totals.closingQuantity}</span>
                </div>
            </div>
        </div>
    );
}

export default LedgerStock;
